/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import classnamesBind from 'classnames/bind';
import { withFormatter } from '@concur/nui-intl-runtime';
import { compose } from '@concur/core-ui-shell';
import IconButton from '@concur/nui-widgets/lib/IconButton/IconButton';
import Menu from './_Menu';
import MenuItem from './_MenuItem';
import styles from './ExpandedSideNav.css';

const CSS_BLOCK = 'sapcnqr-expanded-side-nav';

const ExpandedSideNav = (props) => {
    const {
        formatter,
        inOverlay,
        menuData,
        onCollapse,
        activePathArray,
        menuButtonRef,
        reducedWidth,
        onCloseButtonClick,
        /* eslint-disable react/prop-types */
        menuItems,
        testStylesLoaded,
        lang,
        /* eslint-enable react/prop-types */
        ...otherProps
    } = props;

    const {
        homeMenuItem,
        applicationMenuItems,
        adminMenuItem,
        adminMenuItems,
        linksMenuItem,
        testDriveMenuItem,
        subscribeMenuItem,
    } = menuData;

    const classnames = classnamesBind.bind(styles);
    return (
        <div
            {...otherProps}
            className={classnames(`${CSS_BLOCK}`, {
                [`${CSS_BLOCK}__reduced-width`]: reducedWidth,
            })}
        >
            {inOverlay && (
                <div className={classnames(`${CSS_BLOCK}__close-button-container`)}>
                    <IconButton
                        iconName="close"
                        type="link"
                        innerProps={{
                            className: classnames(`${CSS_BLOCK}__close`),
                        }}
                        iconProps={{
                            size: 'xs',
                        }}
                        ariaLabel={formatter.formattedMessage({ id: 'CoreUI.close' })}
                        onClick={() => {
                            onCloseButtonClick(false);
                        }}
                    />
                </div>
            )}
            <Menu
                className={classnames(`${CSS_BLOCK}__menu`, {
                    [`${CSS_BLOCK}__menu--overlay`]: inOverlay,
                })}
                parentMenuCssBlock={CSS_BLOCK}
                isExpandedSideNav
                disableFocusTrap
                onCollapse={onCollapse}
                menuButtonRef={menuButtonRef}
                isSideNavOverlay={inOverlay}
                id="sideNavBar"
            >
                {homeMenuItem && (
                    <MenuItem
                        {...homeMenuItem}
                        styles={styles}
                        cssBlock={CSS_BLOCK}
                        activePathArray={activePathArray}
                        disableFocusTrap
                        icon
                        isSideNavOverlay={inOverlay}
                    />
                )}
                {testDriveMenuItem && (
                    <MenuItem
                        {...testDriveMenuItem}
                        styles={styles}
                        cssBlock={CSS_BLOCK}
                        activePathArray={activePathArray}
                        isSideNavOverlay={inOverlay}
                        disableFocusTrap
                    />
                )}
                {subscribeMenuItem && (
                    <MenuItem
                        {...subscribeMenuItem}
                        styles={styles}
                        cssBlock={CSS_BLOCK}
                        activePathArray={activePathArray}
                        isSideNavOverlay={inOverlay}
                        disableFocusTrap
                    />
                )}
                {applicationMenuItems
                    && applicationMenuItems.map((item, index) => (
                        <MenuItem
                            {...item}
                            styles={styles}
                            cssBlock={CSS_BLOCK}
                            key={`application${index}`}
                            icon
                            activePathArray={activePathArray}
                            isSideNavOverlay={inOverlay}
                            disableFocusTrap
                        />
                    ))}
                {(adminMenuItem || adminMenuItems || linksMenuItem) && (
                    <MenuItem
                        styles={styles}
                        cssBlock={CSS_BLOCK}
                        isDivider
                        isSideNavOverlay={inOverlay}
                    />
                )}
                {/* Phase 2 (SMNUI-20048): When adminMenuItems array is present, render each
                    admin item as a top-level sidebar item with icon. Falls back to old
                    adminMenuItem (collapsible parent) when array is absent. */}
                {Array.isArray(adminMenuItems) && adminMenuItems.length > 0
                    ? adminMenuItems.map((item, index) => (
                        <MenuItem
                            {...item}
                            styles={styles}
                            cssBlock={CSS_BLOCK}
                            key={`admin${index}`}
                            icon
                            activePathArray={activePathArray}
                            isSideNavOverlay={inOverlay}
                            disableFocusTrap
                        />
                    ))
                    : adminMenuItem && (
                        <MenuItem
                            {...adminMenuItem}
                            activePathArray={activePathArray}
                            styles={styles}
                            cssBlock={CSS_BLOCK}
                            icon
                            isSideNavOverlay={inOverlay}
                            disableFocusTrap
                        />
                    )}
                {linksMenuItem && (
                    <MenuItem
                        {...linksMenuItem}
                        activePathArray={activePathArray}
                        styles={styles}
                        cssBlock={CSS_BLOCK}
                        icon
                        isSideNavOverlay={inOverlay}
                        disableFocusTrap
                    />
                )}
            </Menu>
        </div>
    );
};

ExpandedSideNav.displayName = 'ExpandedSideNav';

ExpandedSideNav.propTypes = {
    isExpandedSideNav: PropTypes.bool,
    reducedWidth: PropTypes.bool,
    menuData: PropTypes.object,
    inOverlay: PropTypes.bool,
    onCollapse: PropTypes.func,
    activePathArray: PropTypes.arrayOf(PropTypes.string),
    menuButtonRef: PropTypes.object,
    onCloseButtonClick: PropTypes.func,
};

export default compose(withFormatter)(ExpandedSideNav);
